import {Observable} from "rxjs";
import {Injectable} from "@angular/core";

import * as _ from "lodash";

import {URLSearchParams} from '@angular/http'
import {HttpBackendService} from "app/services/http-backend.service";
import {Location} from "app/models/location";
import {PagedResult} from "app/models/PagedResult";
import {AssetService} from "app/services/asset.service";
import {ServiceAreaService} from "./serviceArea.service";

@Injectable()
export class LocationService {

  constructor(
    private _http: HttpBackendService
  ) { }

  public getLocationsPerPage(sortBy: string, isDesc: boolean, count: number, skip: number): Observable<PagedResult<Location>> {
    let params = new URLSearchParams;
    let filterRequestStrings: string[] = new Array();

    params.append('$filter', "IsDeleted eq false");
    params.append('$orderby', sortBy + (isDesc ? " desc" : " asc"));
    params.append('$select', "Id,Name,Address,IsOnService,Longitude,Latitude");
    params.append('$top', count ? count.toString() : null);
    params.append('$skip', skip ? skip.toString() : null);
    params.append('$count', "true");

    return this._http.get("/api/odata/locations", params, true)
      .map(resp => {
        let pagedResult = resp.json();
        let result = new PagedResult<Location>();

        result.items = _.map(pagedResult.value, function (value) {
          return LocationService.convertLocationDTO2Object(value);
        });

        result.totalCount = pagedResult["@odata.count"];

        return result;
      });
  }

  public getLocationsForMap(): Observable<Location[]> {
    let params = new URLSearchParams;
    params.append('$filter', "IsDeleted eq false and Parent eq null");
    params.append('$select', "Id,Name,Address,IsOnService,Longitude,Latitude");

    return this._http.get("/api/odata/serviceObjects", params, true)
      .map(resp => {
        let result = _.map(resp.json().value, function (value) {
          return LocationService.convertLocationDTO2Object(value);
        });

        return result;
      });
  }

  public getLocationsIdsWithOpenCall(): Observable<number[]> {

    return this._http.get("/api/serviceObject/getserviceobjectsidwithopencallinfo")
      .map(resp => {
        return _.map(resp.json(), value => value as number);
      });
  }

  public getLocationsIdsWithPlannedService(): Observable<number[]> {

    return this._http.get("/api/serviceObject/getserviceobjectsidwithplannedservice")
      .map(resp => {
        return _.map(resp.json(), value => value as number);
      });
  }

  public getLocationsByName(name: string): Observable<Location[]> {
    let params = new URLSearchParams;
    params.append('$filter', `IsDeleted eq false and (contains(tolower(Name), '${name.toLocaleLowerCase()}') or contains(tolower(Address), '${name.toLocaleLowerCase()}'))`);
    params.append('$select', "Id,Name,Address,ServiceObjectType");

    return this._http.get("/api/odata/locations", params, true)
      .map(resp => {
        let result = _.map(resp.json().value, function (value) {
          return LocationService.convertLocationDTO2Object(value);
        });

        return result;
      });
  }

  public getLocations(): Observable<Location[]> {
    let params = new URLSearchParams;
    params.append('$filter', "IsDeleted eq false");
    params.append('$select', "Id,Name");

    return this._http.get("/api/odata/locations", params, true)
      .map(resp => {
        let result = _.map(resp.json().value, function (value) {
          return LocationService.convertLocationDTO2Object(value);
        });

        return result;
      });
  }

  public getLocationDetails(id: number): Observable<Location> {
    let params = new URLSearchParams;
    params.append('$select', "Id,Name,Address,IsOnService,Longitude,Latitude,IsDeleted");
    params.append('$expand', "AttachedServiceArea,Children($filter=IsDeleted eq false;$orderby=Name asc)");

    return this._http.get("/api/odata/locations(" + id + ")", params, true)
      .map(resp => {
        return LocationService.convertLocationDTO2Object(resp.json())
      });
  }

  public getLocationAddress(id: number): Observable<string> {
    let params = new URLSearchParams;
    params.append('$select', "Address");

    return this._http.get("/api/odata/locations(" + id + ")", params, true)
      .map(resp => {
        return resp.json().Address;
      });
  }
}

export namespace LocationService {
  export function convertLocationDTO2Object(dto: any, location: Location = new Location()): Location {
    location.id = dto.Id;
    location.name = dto.Name;
    location.address = dto.Address;
    location.latitude = dto.Latitude;
    location.longitude = dto.Longitude;
    location.isOnService = dto.IsOnService;
    location.isDeleted = dto.IsDeleted;
    location.type = dto.ServiceObjectType != null ? dto.ServiceObjectType.Name : "-";

    if(dto.AttachedServiceArea != null)
    {
      location.serviceArea = ServiceAreaService.convertServiceAreaDTO2Object(dto.AttachedServiceArea);
    }

    location.children = _.map(dto.Children, function (value) {
      return AssetService.convertAssetDTO2Object(value);
    });

    return location;
  };
}



// WEBPACK FOOTER //
// /app/SPA/src/app/services/location.service.ts